import TakersContainer from "pages/PanelPage/components/selectedAssessment/assessmentResults/TakersContainer/TakersContainer";

export default TakersContainer;
